module.exports = function () {

    $(document).ready(function () {
        $(document).on('click', '.js-datepicker', function (e) {

            $(this).datepicker({
                autoclose: true,
                format: "dd/mm/yyyy"
            });

        }).on('change', '.js-datepicker', function (e) {

            var report = this.getAttribute('data-report');
            var $form = $(this).closest('form');

            $('.js-datepicker').each(function () {
                $(this).change(function () {
                    if ($('input[name="dateFrom"', $form ).val() != '' && $('input[name="dateTo"', $form).val() != '') {
                        $('#'+report+'-pdf, #'+report+'-csv').removeAttr('disabled');
                    }
                })
            });
        });





        // on('click', '.report-daterange', function (e) {
        //
        //     var report = this.getAttribute('data-report');
        //
        //     $("#"+report).toggle();
        //
        //     $('.js-datepicker').each(function () {
        //         $(this).change(function () {
        //             if ($('input[name="dateFrom_'+report+'"').val() != '' && $('input[name="dateTo_'+report+'"').val() != '') {
        //                 $('#'+report+'-pdf, #'+report+'-csv').removeAttr('disabled');
        //             }
        //         })
        //     });
        // });
    });
}();
